export const PIN_NOT_OPERATIONAL = "Sorry we are not operational at your location yet, we will be there soon!";
export const PIN_REQUIRED = "PIN code is required for the visit address.";

export function normalizePincode(raw) {
  return String(raw || "").replace(/\D/g, "").slice(0, 6);
}

export function extractPincode(...sources) {
  for (const source of sources) {
    const text = String(source || "").trim();
    if (!text) continue;
    const digits = text.replace(/\D/g, "");
    if (/^\d{6}$/.test(text.replace(/\s/g, "")) || (digits.length === 6 && /^\d+$/.test(text.replace(/\s/g, "")))) {
      return digits.slice(0, 6);
    }
    const match = text.match(/(^|\D)(\d{6})(\D|$)/);
    if (match) return match[2];
    if (digits.length === 6) return digits;
  }
  return "";
}

export function pinServiceError(pin, allowed, { listReady = true, requireComplete = true } = {}) {
  const n = extractPincode(pin) || normalizePincode(pin);
  if (n.length !== 6) return requireComplete ? PIN_REQUIRED : "";
  if (!listReady) return "";
  if (!Array.isArray(allowed) || !allowed.includes(n)) return PIN_NOT_OPERATIONAL;
  return "";
}
